import { completeTxBuilderRecipeGroups } from 'js/lib/RecipeBuilderUtils';
import React from 'react';
import { SchemaBrowserType, SchemaEditorViewModeType } from '../../../constants/schemaEditor';
import DataSamplesProcessor from '../../../lib/DataSamplesProcessor';
import TransformsUtils from '../../../lib/TransformsUtils';
import RecipeBuilderGrid from '../../recipeBuilder/RecipeBuilderGrid';
import RecipeBuilderGridControls from '../../recipeBuilder/RecipeBuilderGridControls';
import AutoSizingSearchInput from '../AutoSizingSearchInput';
import NoContentTextView from '../NoContentTextView';

import { connect } from 'react-redux';
import { resetRecipeGroups, setRecipeGroups } from '../../../actions';
import { GET_DATA_SAMPLES_REQUEST } from '../../../constants/actionTypes';

class SchemaViewer extends React.PureComponent {
  state = {
    selectedViewMode: this.props.defaultViewMode || SchemaEditorViewModeType.TABLE,
    searchText: '',
  };

  componentDidMount() {
    this._initRecipeGroups();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.dataSet?.id !== this.props?.dataSet?.id ||
      prevProps.transforms !== this.props.transforms
    ) {
      this._initRecipeGroups();
    }
  }

  componentWillUnmount() {
    this.props.resetRecipeGroups();
  }

  /**
   * @param mode CODE | TABLE
   */
  _handleViewModeChanged = (mode) => {
    this.setState({ selectedViewMode: mode });
  };

  render() {
    const {
      dataSet,
      numSamples,
      liveSamples,
      showMeta,
      showCharacteristics,
      compactHeader,
      isLoadingSamples,
      onNumSamplesChanged,
      onShowMetaChanged,
      loadingSamples,
      onRefreshSamples,
      darkEditor,
      shouldShowEmptyState = false,
      emptyStateContent = null,
    } = this.props;
    const { selectedViewMode, searchText } = this.state;

    const showEmptyState = shouldShowEmptyState && emptyStateContent; // only show empty state if both flag is true and content exists

    return (
      <>
        <div className="recipe-samples-header">
          <div className="recipe-samples-header-left-content">
            <RecipeBuilderGridControls
              dataSet={dataSet}
              numSamples={numSamples}
              liveSamples={liveSamples}
              selectedViewMode={selectedViewMode}
              showMeta={showMeta}
              compactHeader={compactHeader}
              loadingSamples={loadingSamples}
              onRefreshSamples={onRefreshSamples}
              onNumSamplesChanged={onNumSamplesChanged}
              onShowMetaChanged={onShowMetaChanged}
              onDownloadSamples={this._handleDownloadSamples}
              onViewModeChanged={this._handleViewModeChanged}
            />
          </div>
          {!compactHeader && (
            <AutoSizingSearchInput
              searchText={searchText}
              onChange={this._handleSearchTextChanged}
            />
          )}
        </div>

        {showEmptyState ? (
          <NoContentTextView
            title={<div>{emptyStateContent.title}</div>}
            subtitle={<div>{emptyStateContent.subtitle}</div>}
          />
        ) : (
          <RecipeBuilderGrid
            gridId={SchemaBrowserType.OUTPUT}
            dataSet={dataSet}
            searchText={searchText}
            selectedViewMode={selectedViewMode}
            showMeta={showMeta}
            showCharacteristics={showCharacteristics}
            darkEditor={darkEditor}
            isLoading={isLoadingSamples}
            {...this.props}
          />
        )}
      </>
    );
  }

  _initRecipeGroups = () => {
    const { dataSet, transforms, setRecipeGroups } = this.props;

    if (!dataSet) {
      return;
    }

    const txSpec = dataSet.custom_config?.txSpec;
    let recipeGroups;

    if (txSpec?.v === 2) {
      recipeGroups = txSpec.spec;
    } else {
      recipeGroups = TransformsUtils.getUpgradedTxSpec(dataSet, transforms);
    }

    recipeGroups = completeTxBuilderRecipeGroups(recipeGroups, transforms);

    setRecipeGroups(recipeGroups);
  };

  _handleDownloadSamples = (format) => {
    const { dataSet, schema, samples, nestedSamples } = this.props;
    DataSamplesProcessor.downloadSamples(
      { input: schema },
      { input: { nested: nestedSamples, flat: samples } },
      format,
      dataSet ? `nexset-${dataSet.id}-` : '',
    );
  };

  _handleSearchTextChanged = (searchText) => {
    this.setState({ searchText });
  };
}

SchemaViewer.defaultProps = {
  showSamples: true,
};

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { transforms },
    recipeBuilder: { recipeGroups },
    request,
  } = state;

  return {
    loadingSamples: !!request[GET_DATA_SAMPLES_REQUEST],
    transforms,
    recipeGroups,
  };
};

export default connect(mapStateToProps, {
  setRecipeGroups,
  resetRecipeGroups,
})(SchemaViewer);
